import { Box, Grid, Typography } from '@mui/material'
import { BerthPlanningViewStore } from '@planning/pages/BerthPlanning/Stores/BerthPlanningViewStore'
import { VesselVisitBerthAndTimingFormStore } from '@planning/pages/VesselVisit/Stores/VesselVisitBerthAndTimingFormStore'
import { useTranslate } from '@tolgee/react'
import { WarningIcon } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { NumberFieldWithUnit } from '../../atoms/NumberFieldWithUnit'

export const QuayMeterMarkingsFields = observer(
  ({
    store,
    berthPlanningViewStore,
  }: {
    store: VesselVisitBerthAndTimingFormStore
    berthPlanningViewStore: BerthPlanningViewStore
  }) => {
    const { t } = useTranslate()

    const { minQmmFrom, maxQmmTo, isQmmOutOfRange } = store
    const warningMessage = isQmmOutOfRange
      ? `${t('currentQmmIsOutsideThePierRange', 'Current QMM is outside the pier range of')} ${minQmmFrom}m - ${maxQmmTo}m`
      : null

    const onChangeQmm = (qmmRange: 'from' | 'to', value: number | '') => {
      const normalizedValue = value === '' ? 0 : Number(value)

      if (qmmRange === 'from') {
        berthPlanningViewStore.calculateQmmBasedOnBerthAndVesselLength(normalizedValue)
      } else {
        const normalizedQMMFrom =
          store.qmmFrom.value === '' ||
          store.qmmFrom.value === null ||
          isNaN(Number(store.qmmFrom.value))
            ? 0
            : Number(store.qmmFrom.value)

        berthPlanningViewStore.calculateQmmBasedOnBerthAndVesselLength(
          normalizedQMMFrom,
          normalizedValue,
          true,
        )
      }

      if (value === null || value === '' || isNaN(Number(value))) {
        berthPlanningViewStore.setSelectedBerths([])
        store.berths.setValue([])
      } else {
        berthPlanningViewStore.setSelectedBerths(berthPlanningViewStore.berthsByQmmRange)
        store.berths.setValue(berthPlanningViewStore.berthsByQmmRange)
      }
    }

    return (
      <>
        <Grid size={{ xs: 12 }}>
          <Typography variant='subtitle1'>
            {t('quaysMeterMarkings', 'Quay’s meter markings')}
          </Typography>
        </Grid>

        <Grid size={{ xs: 6 }}>
          <NumberFieldWithUnit
            name='qmmFrom'
            label={t('from', 'From')}
            unit='m'
            fieldStoreProps={store.qmmFrom.props}
            onChange={value => onChangeQmm('from', value)}
            restrictionMode='nonNegative'
          />
        </Grid>

        <Grid size={{ xs: 6 }}>
          <NumberFieldWithUnit
            name='qmmTo'
            label={t('to', 'To')}
            unit='m'
            fieldStoreProps={store.qmmTo.props}
            onChange={value => onChangeQmm('to', value)}
            restrictionMode='nonNegative'
          />
        </Grid>

        {warningMessage && (
          <Grid size={{ xs: 12 }}>
            <Box display='flex' alignItems='center' gap={1}>
              <WarningIcon color='warning' fontSize='small' />
              <Typography variant='body2' color='#7A4F01'>
                {warningMessage}
              </Typography>
            </Box>
          </Grid>
        )}
      </>
    )
  },
)
